import { render, staticRenderFns } from "./ProgramAdd.vue?vue&type=template&id=0a813246&scoped=true&"
import script from "./ProgramAdd.vue?vue&type=script&lang=js&"
export * from "./ProgramAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProgramAdd.vue?vue&type=style&index=0&id=0a813246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a813246",
  null
  
)

export default component.exports